export const experienceData = [
    {
        id: 1,
        company: 'Matdun',
        jobtitle: 'Full Stack Developer',
        startYear: 'May 2023',
        endYear: 'Present'
    }
]